import { gql } from '@apollo/client'

import { moveFields, noteAttachmentFields } from './moves.queries'

export const createMove = gql`
mutation CreateMove($payload: CreatePublicMoveDto!, $promoCode: String) {
  createMove(payload: $payload, promoCode: $promoCode){
    ${moveFields}
  }
}
`

export const updateCustomer = gql`
mutation UpdateCustomer($movePublicId: String!, $payload: MoveCustomerDto!) {
  updateCustomer(movePublicId: $movePublicId, payload: $payload) {
    ${moveFields}
  }
}
`

export const updateMove = gql`
mutation UpdateMove($movePublicId:String!, $payload: UpdateMovePublicDto!) {
  updateMove(movePublicId: $movePublicId, payload: $payload){
    ${moveFields}
  }
}
`

export const refreshQuotes = gql`
mutation RefreshQuotes($movePublicId: String!) {
  refreshQuotes(movePublicId: $movePublicId) {
    ${moveFields}
  }
}
`

export const selectQuote = gql`
mutation SelectQuote($movePublicId: String!, $quoteId: String) {
  selectQuote(movePublicId: $movePublicId, quoteId: $quoteId) {
    ${moveFields}
  }
}
`

export const prepareMoveDeposit = gql`
mutation PrepareMoveDeposit($movePublicId: String!) {
  prepareMoveDeposit(movePublicId: $movePublicId) {
    ${moveFields}
  }
}
`

export const prepareMoveBalancePayment = gql`
mutation PrepareMoveBalancePayment($movePublicId: String!) {
  prepareMoveBalancePayment(movePublicId: $movePublicId) {
    ${moveFields}
  }
}
`

export const applyPromoCode = gql`
mutation ApplyPromoCode($movePublicId: String!, $promoCode: String) {
  applyPromoCode(movePublicId: $movePublicId, promoCode: $promoCode) {
    ${moveFields}
  }
}
`

export const acceptQuote = gql`
mutation AcceptQuote($movePublicId: String!, $payload: AcceptQuoteDto!) {
  acceptQuote(movePublicId: $movePublicId, payload: $payload) {
    ${moveFields}
  }
}
`

export const uploadNoteAttachment = gql`
mutation UploadNoteAttachment($movePublicId: String!, $payload: UploadAttachmentDto!) {
  uploadNoteAttachment(movePublicId: $movePublicId, payload: $payload) {
    id
    notes {
      fromCustomer {
        attachments {
          ${noteAttachmentFields}
        }
      }
    }
  }
}
`

export const deleteNoteAttachment = gql`
mutation DeleteNoteAttachment($movePublicId: String!, $payload: DeleteAttachmentDto!) {
  deleteNoteAttachment(movePublicId: $movePublicId, payload: $payload) {
    id
    notes {
      fromCustomer {
        attachments {
          ${noteAttachmentFields}
        }
      }
    }
  }
}
`
